module.exports = __webpack_public_path__ + "static/media/avatar-3.9842db4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/avatars/avatar-3.png
// module id = 242
// module chunks = 0